import styles from './PaymentCheck.module.css'
import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useApiQuery from "../ApiQuery/UseApiQuery";
import WaitLoader from "../WaitLoader/WaitLoader";
import InputItem from "../FormTemplate/InputItem/InputItem";

interface IMessageToMain
{
    orderId:string
    sessionId:string
    state:boolean
}
interface ClientInfoInt
{
    user: string
    pass?: string
    existUser:boolean
    contactData?: {
        phone?:string
        eMail?:string
    }
    textUser?:string
    textPass?:string

}


interface ICompleteOrderData
{
    orderId:string
    sessionId?:string
    senderId?:string
}

interface CompleteOrderDataInt
{
    orderId:string
    sessionId?:string
    senderId?:string
}

export default function PaymentCheck()
{
    const location = useLocation()
    const [orderState, setOrderState]= useState<IMessageToMain>()

    const completeOrderData = useRef<CompleteOrderDataInt>()
    const [ldrCompleteOrder,rsCompleteOrder,exCompleteOrder] = useApiQuery("/sell/sim/order/complete","post",completeOrderData);
    const [client, setClient] = useState<ClientInfoInt>()
    const navigate = useNavigate()


    useEffect(()=>{
        if(!location?.pathname)return
        parseLocation(location?.pathname)
    },[location])

    useEffect(()=>{
        if(!orderState) return
        loadOrderComplete()
    },[orderState])

    useEffect(()=>console.log("data", orderState),[orderState])

    const handleMove = () =>{
        console.log("postMessage", orderState)
        window?.top?.postMessage(orderState,'*')
        navigate('/lk')

    }

    const loadOrderComplete = ()=>{
        if(!orderState) return
        completeOrderData.current ={
            orderId: orderState?.orderId,
            sessionId: orderState?.sessionId,
            senderId: "bank success url"

        }
        exCompleteOrder().then((e)=>{
            console.log(e)
            if(e?.success)
            {
                setClient(e?.payload)
                setTimeout(()=>handleMove(),20000)
            }
        })
    }


    const parseLocation = (location: string) =>{
        try {
            let data = location?.match(/(?<=\/payment\/).*$/uig)
            if(data)
            {
                const x = data ? atob(data[0])?.split(':') : ['0','0']
                setOrderState({
                    orderId: x[0],
                    sessionId: x[1],
                    state : true
                })
                return;
            }
            setOrderState({
                orderId: "-",
                sessionId: "-",
                state : false
            })

        }   catch (e) {
            setOrderState({
                orderId: "-",
                sessionId: "-",
                state : false
            })
        }
    }

    const buildSuccess = () =>{
        if(!orderState)return null
        if(!orderState?.state) return null
        return (
            <>
                {buildLk()}
            </>
        )
    }

    const buildFailure = ()=>{
        if(!orderState)return null
        if(orderState?.state === true) return null
        return (
            <div className={[styles.title, styles.fail].join(' ')}>
                Ошибка платежа, обратитесь по телефону +7-999-304-6060
            </div>
        )
    }

    const buildLk = ()=>{
        if(!client)return null
        const lkText = client?.existUser ? "Ваш личный кабинет уже существует" : "Вам создан личный кабинет"
        return (
            <div className={styles.mainCnpont} >

                <WaitLoader loading={ldrCompleteOrder} api={rsCompleteOrder} onlyLoading={true}>
                    <div>Поздравляем Ваш заказ создан</div>
                    <div>Номер заказа : <span>{orderState?.orderId}</span></div>
                    <div className={styles.lkDiv}>{lkText}</div>
                    <div className={styles.lkDiv}>В личном кабинете Вам будет предоставлен трэк отслеживания заказа и многое другое...</div>
                    <div className={[styles.pCont, styles.clData].join(' ')}>
                        <div className={styles.lgCont}>
                            <InputItem
                                title={client?.textUser}
                                val={client?.user ? client?.user : ""}
                                placeHolder={"XXXXXXXXXX"}
                                mode={""}

                            />
                            <InputItem
                                title={client?.textPass}
                                val={client?.pass ? client?.pass : ""}
                                placeHolder={"XXXXXXXXXX"}
                                mode={""}

                            />

                        </div>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-primary"
                                onClick={()=>handleMove()}
                        >Перейти</button>

                    </div>



                </WaitLoader>



            </div>

        )
    }


    return(
        <div className={styles.mainCont}>
            {buildSuccess()}
            {buildFailure()}
        </div>
    )
}